import axios from "axios";
import Swal from "sweetalert2";
import router from "@/router"; // sesuaikan path router kamu jika berbeda

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
}

// Global axios config
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

// Untuk Axios versi baru
axios.defaults.withXSRFToken = true;

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const method = config.method?.toLowerCase();

    if (!config.headers) {
      config.headers = {};
    }

    /**
     * Kirim URL frontend aktif ke backend.
     */
    config.headers["X-Frontend-Url"] = window.location.href;

    /**
     * Karena JWT sekarang pindah ke HttpOnly cookie,
     * jangan lagi kirim Authorization dari localStorage.
     */
    // if (config.headers.Authorization) {
    //   delete config.headers.Authorization;
    // }

    // if (config.headers.common?.Authorization) {
    //   delete config.headers.common.Authorization;
    // }

    /**
     * Tambahkan CSRF token manual untuk request mutasi.
     */
    if (["post", "put", "patch", "delete"].includes(method)) {
      const xsrfToken = getCookie("XSRF-TOKEN");

      if (xsrfToken) {
        config.headers["X-XSRF-TOKEN"] = xsrfToken;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    if ([401, 403, 419].includes(status)) {
      Swal.fire({
        icon: "error",
        title: "Sesi habis",
        text: "Sesi Anda telah berakhir. Silakan masuk kembali.",
        confirmButtonText: "OK",
      }).then(() => {
        router.push("/logout");
      });
    }

    return Promise.reject(error);
  },
);

export default axios;
